import { Headline, Icon, Link } from '@joor/design-system'
import styled from 'styled-components'

import { PHOTO_GALLERY, STYLES_BULK_IMAGE_UPLOADER } from 'routes/paths'

import messages from 'features/Linesheets/Modals/ManageImagesModal/manageImagesModal.messages'
import useStore from 'features/Linesheets/Modals/ManageImagesModal/store/useManageImagesStore'

const EmptyGalleryContainer = styled.div`
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--color-primary-200);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  span {
    width: 108px;
    height: 108px;

    svg {
      width: 108px;
      height: 108px;
      --main-color: var(--color-primary-300);
      &:hover {
        --main-color: var(--color-primary-300);
      }
    }
  }
`

const StyledLink = styled(Link)`
  display: block;
  text-decoration: none;

  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 3px;
    margin-right: 8px;
    background-color: var(--color-secondary-800);
    border-radius: 50%;
    vertical-align: middle;
  }

  &&&:visited {
    color: var(--color-secondary-800);
  }
`

const EmptyGallery = (): JSX.Element => {
  const search = useStore((state) => state.search)

  return (
    <EmptyGalleryContainer>
      <Icon iconName="image" />
      {search ? (
        <Headline type="h4" color="primary-600">
          <span>{messages.noResultsFound}</span>
          <strong>{`"${search}"`}</strong>
        </Headline>
      ) : (
        <>
          <Headline type="h3" color="primary-600">
            {messages.manageYourImages}
          </Headline>
          <div>
            <StyledLink
              target="_blank"
              href={PHOTO_GALLERY}
              letterSpacing="normal"
              margin="0 0 20px"
            >
              {messages.browseAllImages}
            </StyledLink>
            <StyledLink
              target="_blank"
              href={STYLES_BULK_IMAGE_UPLOADER}
              letterSpacing="normal"
            >
              {messages.uploadNewImages}
            </StyledLink>
          </div>
        </>
      )}
    </EmptyGalleryContainer>
  )
}

export default EmptyGallery
